module.exports = "/src/views/player/help/images/azart2.jpg";